<template>
	<div class="question">
        <img src="../../../static/images/icon/ques.png" alt="">
		<div class="main">
			<div class="ques">
                <h5>您的年龄是？</h5>
                <el-radio-group v-model="age">
                    <el-radio-button label="1">50岁以上</el-radio-button>
                    <el-radio-button label="2">50岁以下</el-radio-button>
                </el-radio-group>
            </div>
            <div class="ques">
                <h5>您想重点调理的方向是?</h5>
                <el-radio-group v-model="nurse">
                    <el-radio-button label="1">慢性病</el-radio-button>
                    <el-radio-button label="2">养生</el-radio-button>
                    <el-radio-button label="3">其他</el-radio-button>
                </el-radio-group>
            </div>
            <div class="ques">
                <h5>您是否有听过其他中医课程？</h5>
                <el-radio-group v-model="course">
                    <el-radio-button label="1">是</el-radio-button>
                    <el-radio-button label="2">否</el-radio-button>
                </el-radio-group>
            </div>

            <div class="cbtn" @click="submit">
				<div class="text">下一步</div>
			</div>
		</div>

		<div class="mask" v-if="loading">
			<div class="bg-white">
				<i class="el-icon-loading"></i>
				<p>正在加载中...</p>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import { getAgent } from '@/utils/index'

	export default {
		data () {
			return {
                age: '',
                nurse:'',
                course:'',
				loading:false,
				pathId:'',
				openType:''
			}
		},
		created(){
			this.pathId = this.$route.query.pathId
			this.openType = this.$route.query.type || ''
		},
		methods:{
            submit(){
                if(!this.age){
                    this.$message({message: '请选择您的年龄'});
                    return false
                }
                if(!this.course){
                    this.$message({message: '请选择您的调理方向'});
                    return false
                }
                if(!this.nurse){
                    this.$message({message: '请选择您是否听过其他课程'});
                    return false
                }
				if(!this.pathId){
					this.loading = false
					this.$message({message: '投放id异常'});
					return false
				}
                this.loading = true
				this.commonPoint(this.pathId,this.$route.query.productId,'ecApplyNow',2)

                let params = {
                    qsAge: this.age,
                    qsIsohterCourse: this.course,
                    qsConditionDirection: this.nurse,
                    clickId: this.pathId,
					productId: this.$route.query.productId,
                }
				axios({
					method:"POST",
					url:`${this.$baseURL}/insetQsInfo`,
					params:params
				}).then(res => {
					if(res.data.code == 200){
						this.openType == 'cust' ? this.custOpen() : this.getToken()
					}else{
						this.$message({message: res.data.message});
					}
				})
            },
			custOpen(){
				axios({
					method:"POST",
					url:`${this.$baseURL}/getWechatLinkFree`,
					params:{
						orderId: this.$route.query.orderId,
						productId: this.$route.query.productId,
						pathId: this.pathId
					}
				}).then(res => {
					if(res.data.code == 200){
						let data = res.data.data
						let path = data.link_url + '?customer_channel=' + data.orderId + '_H5' + '_' + this.$route.query.productId
						this.openUrl(path)
					}else{
						this.$message({message: res.data.message});
					}
				})
			},
			openUrl(path){
				if(getAgent()){
					window.open(path)
				}else{
					window.location.href = path
				}
			},
			getToken(){
				axios.get(`${this.$siteURL}/wxapi/cgi-bin/token?grant_type=client_credential&appid=${this.$wechatAppid}&secret=${this.$wechatSecret}`).then(res => {
					if(res.status == 200){
						this.getScheme(res.data.access_token)
					}
				}).catch(err => {
					console.log(err)
				})
			},
			getScheme(token){
				axios({
					method:"POST",
					url:`${this.$siteURL}/wxapi/wxa/generatescheme?access_token=${token}`,
					data:{
						jump_wxa:{
							query:"pathId="+this.pathId
						}
					}
				}).then(res => {
					window.location.href = res.data.openlink
					this.loading = false
				})
			},
		}
	}
</script>

<style scoped>
	.question{background: #F2F2F2;height: 100vh;}
    .main{margin: -15px 12px 0;background: #fff;padding: 15px;border-radius: 15px;z-index: 2;position: relative;height: 75vh;}
    .main h5{font-size: 16px;color: #333;margin: 10px 0;}
    .main .ques{margin-bottom: 25px;}
    .cbtn{margin-top: 25vh;padding: 10px 25px;background: linear-gradient(90deg, #ff4242 0%, #ff7e18 100%);text-align: center;border-radius: 30px;}
	.cbtn .text{color: #fff;font-size: 20px;}
    .mask{position: fixed;background: rgba(0, 0, 0, .2);width: 100%;height: 100%;left: 0;top: 0;z-index: 9;}
	.bg-white{background: #fff;border-radius: 30px;padding: 30px;margin-top: 40vh;width: 160px;margin-left: calc(50vw - 105px);color: #ff6826;font-size: 16px;text-align: center;}
	.bg-white i{font-size: 28px;margin-bottom: 20px;}
</style>



// WEBPACK FOOTER //
// src/views/product/question.vue